import clsx from "clsx";

// Interfaces
import { ITabTitle } from "./interfaces";

// MUI
import { Typography, Stack, Box } from "@mui/material";

// Icons
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export default function TabTitle(props: Readonly<ITabTitle>) {
	const { title, selected, error, disabled = false, badgeValue = "" } = props;
	return (
		<Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
			<Typography
				className={clsx({
					"!font-sans normal-case text-default": true,
					"text-white": selected || disabled,
					"!text-alert in-error": !selected && Boolean(error),
				})}
			>
				{title}
			</Typography>

			<CustomBadge badgeValue={badgeValue} selected={selected} />

			<Stack
				className={clsx({
					hidden: !error || selected,
					"!text-alert in-error": Boolean(error),
				})}
			>
				<ErrorOutlineRoundedIcon fontSize={"small"} className="!text-alert ml-[5px]" />
			</Stack>
		</Stack>
	);
}

type TCustomBadgeProps = {
	badgeValue: string;
	selected: boolean;
};

function CustomBadge(props: Readonly<TCustomBadgeProps>) {
	const { badgeValue, selected } = props;

	if (!badgeValue) {
		return null;
	}

	return (
		<Box
			className={clsx({
				"w-5 h-5": true,
				"font-sans bg-white text-primary text-[12px] font-normal": true,
				"rounded-full flex items-center justify-center !pt-[0.5px]": true,
				"ml-2": true,
				"!bg-primary !text-white": !selected,
			})}
		>
			{badgeValue}
		</Box>
	);
}
